
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { ExtraRegistrationField } from "@/model/ExtraRegistrationField";
import { IBriefingPathway } from "@/model/BriefingPathway";

interface ISelectableBriefingPathway extends IBriefingPathway {
    isSelected: boolean;
}

@Component({ components: { } })
export default class PathwayFilterDialogue extends Vue {

    @Prop({ required: true })
    value!: boolean;

    @Prop({ required: true })
    field!: ExtraRegistrationField | null;

    @Prop({ required: true })
    pathwayList!: Array<IBriefingPathway>;

    get title(): string {
        return `Selected Pathways for: ${this.field?.label ?? "- - -"}`;
    }

    get pathwayOptions(): Array<ISelectableBriefingPathway> {
        return this.pathwayList.map(p => {
            const item = p as ISelectableBriefingPathway
            item.isSelected = (this.field?.pathwayIds?.indexOf(p.pathwayID) ?? -1) > -1;
            return item;
        });
    }

    get selectedIds(): Array<string> {
        return this.pathwayOptions.filter(p => p.isSelected).map(p => p.pathwayID);
    }

    get isAllPathways(): boolean {
        return this.field?.isAllPathways ?? true;
    }
    set isAllPathways(value: boolean) {
        if(this.field != null) this.field.isAllPathways = value; // hmmm...
    }

    @Watch("selectedIds", { immediate: false, deep: false })
    onSelectedChange() {
        this.$emit("changed", this.selectedIds);
    }

    clearAll() {
        this.$emit("pathway-clear-all");
    }

    toggle(pathway: ISelectableBriefingPathway) {
        if(this.isAllPathways) {
            return;
        }
        this.$emit("pathway-changed", pathway.pathwayID);
    }

    close() {
        this.$emit("input", false);
    }
}
